import React, { useState } from "react";

export const YearSelector = ({ setYear, year }) => {
  // Hardcode the years you want to support
  const assessmentYears = [
    { value: "2024-2025", label: "AY 2024-2025" },
    { value: "2025-2026", label: "AY 2025-2026" },
    { value: "2026-2027", label: "AY 2026-2027" },
  ];

  // Set default selected year to the latest
  const [selectedAY, setSelectedAY] = useState(year || "2026-2027");

  return (
    <div className="dropdown">
      <button
        className="btn year-drop d-flex btn-secondary dropdown-toggle dropdown-toggle-no-caret px-4 "
        style={{ background: "#454545" }}
        role="button"
        id="dropdownMenuLink"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        AY {selectedAY}
      </button>
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
        {assessmentYears.map((ay) => (
          <li key={ay.value}>
            <button
              className="dropdown-item"
              type="button"
              onClick={() => {
                setSelectedAY(ay.value);
                setYear(ay.value);
              }}
            >
              {ay.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};